/**
 * MapMyIndia (MMI) Stores Service
 * Migrated from 3in1cms legacy/storesFromMMI.ts
 */

import { request } from "../core/request";
import { OPERATION_IDS } from "./constants";
import type { MmiResponse } from "../types/storesFromMMIType";

/**
 * Fetch and store MMI token
 * @param mobileNo - Mobile number
 * @returns MMI token string
 */
const fetchAndStoreMmiToken = async (mobileNo: string): Promise<string> => {
  const data = (await request<
    MmiResponse,
    {
      token: string;
      address: string;
      eventCode: string;
      eloc: null;
      lat: null;
      longitude: null;
      page: string;
      recordType: string;
      mobileNo: string;
    }
  >({
    operationId: OPERATION_IDS.mmi,
    requestData: {
      token: "",
      address: "",
      eventCode: "FETCH_TOKEN",
      eloc: null,
      lat: null,
      longitude: null,
      page: "1",
      recordType: "BFLB2B",
      mobileNo,
    },
  })) as MmiResponse;

  const mmiToken = data?.token || "";

  // Store token in localStorage (client-side only)
  if (typeof window !== "undefined") {
    const expiry = Date.now() + 8 * 60 * 60 * 1000; // 8 hours in ms
    localStorage.setItem("mmiToken", mmiToken);
    localStorage.setItem("mmiTokenExpiry", expiry.toString());
  }

  return mmiToken;
};

/**
 * Get nearest stores using MapMyIndia API
 * @param mobileNo - Mobile number
 * @param lat - Latitude
 * @param long - Longitude
 * @returns MMI response with nearest stores
 */
export const getNearestStores = async (
  mobileNo: string,
  lat: string,
  long: string
): Promise<MmiResponse> => {
  let mmiToken = "";

  // Get token from localStorage (client-side only)
  if (typeof window !== "undefined") {
    mmiToken = localStorage.getItem("mmiToken") ?? "";
  }

  try {
    if (!mmiToken) {
      mmiToken = await fetchAndStoreMmiToken(mobileNo);
    }
  } catch (error) {
    console.error("Error fetching mmiToken:", error);
  }

  try {
    const response = (await request<
      MmiResponse,
      {
        token: string;
        address: string;
        eventCode: string;
        eloc: null;
        lat: string;
        longitude: string;
        page: string;
        recordType: string;
        mobileNo: string;
      }
    >({
      operationId: OPERATION_IDS.mmi,
      requestData: {
        token: mmiToken,
        address: "",
        eventCode: "FETCH_DELEARS",
        eloc: null,
        lat,
        longitude: long,
        page: "1",
        recordType: "BFLB2B",
        mobileNo: mobileNo,
      },
    })) as MmiResponse;

    return response;
  } catch (error) {
    console.error("Error in getNearestStores", error);
    throw error;
  }
};
